import { Component, Input, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Scroller } from 'primeng/scroller';

interface LazyEvent {
  first: number;
  last: number;
}

@Component({
  selector: 'ness-user-history',
  templateUrl: './user-history.component.html',
  styles: [
    `:host ::ng-deep {
            .p-scroller-viewport {
                flex: none;
            }
        }`
  ]
})
export class UserHistoryComponent implements OnInit {
  @ViewChild('sc') sc: Scroller;

  historyItemsDisplaying: ServerModels.ENESS_UserHistory[] = [];
  lazyLoading: boolean = true;
  loadLazyTimeout: any;

  private _userHistory: ServerModels.ENESS_UserHistory[] = [];
  get userHistory(): ServerModels.ENESS_UserHistory[] {
    return this._userHistory;
  }
  @Input() set userHistory(items: ServerModels.ENESS_UserHistory[]) {
    this._userHistory = [...items];
  }

  constructor(private cdr: ChangeDetectorRef) { }
  
  ngOnInit() {
    this._setUserMessage();
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }
  public onLazyLoad(event: LazyEvent) {
    this.lazyLoading = true;
    this._setUserMessage();
    if (this.loadLazyTimeout) {
      clearTimeout(this.loadLazyTimeout);
    }

    //imitate delay of a backend call
    this.loadLazyTimeout = setTimeout(() => {
      const { first, last } = event;
      const lazyItems = [...this.userHistory];

      this.userHistory = lazyItems;
      this.lazyLoading = false;
    }, Math.random() * 100 + 250);
  }


  private _setUserMessage() {
    if (!!this.userHistory.length) {
      this.historyItemsDisplaying = this.userHistory;
    } else {
      let emptyData = {
        UserHistoryId: null,
        CreatedOn: null,
        Comments: 'No user history found.'
      } as ServerModels.ENESS_UserHistory;

      this.historyItemsDisplaying.push(emptyData);
    }    
  }
}
